/* eslint-disable @typescript-eslint/naming-convention */
import { environment } from './environments/environment';
import { Amplify } from 'aws-amplify';

console.log('Use environment for', environment.stage);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.userPoolId,
      userPoolClientId: environment.clientId,
      loginWith: {
        oauth: {
          domain: `${environment.cognitoDomainPrefix}.auth.${environment.region}.amazoncognito.com`,
          scopes: ['email', 'openid', 'profile', 'phone', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [environment.cognitoRedirectUri],
          redirectSignOut: [environment.cognitoLogoutUri],
          responseType: 'code',
        },
      },
    },
  },
});
